import { Tooltip } from 'antd';

import infoIcon from '../../assets/Global/info.svg';
import { LocalImage } from '../Image';

export function InfoTip({
  title,
  place,
}: {
  title: string;
  place:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight';
}) {
  return (
    <Tooltip title={title} placement={place} color="#282A2E">
      <LocalImage src={infoIcon} />
    </Tooltip>
  );
}
